import { createFileRoute, notFound } from "@tanstack/react-router"
import { SessionChat } from "@/features/chat/session-chat"

export const Route = createFileRoute("/_app/chat/$sessionId")({
  staticData: { titleKey: "chat.conversation.title" },
  params: {
    parse: (p) => {
      const id = Number(p.sessionId)
      if (!Number.isInteger(id) || id <= 0) throw notFound()
      return { sessionId: String(id) }
    },
    stringify: (p) => p,
  },
  component: SessionPage,
})

function SessionPage() {
  const { sessionId } = Route.useParams()
  return (
    <div className="h-full">
      <SessionChat key={sessionId} sessionId={Number(sessionId)} />
    </div>
  )
}
